import { useLocation, Link as RouterLink } from "react-router-dom";
import clsx from "clsx";

import { Text } from "./base";

// The fine-tuning lifecycle, in order. Each admin page is one stage; the stepper makes the
// train -> deploy -> eval -> release pipeline explicit and navigable across all four pages.
const STEPS = [
  { n: 1, label: "Curate", sub: "Datasets", to: "/admin/fine-tuning-datasets" },
  { n: 2, label: "Train", sub: "Trainings", to: "/admin/fine-tuning-jobs" },
  { n: 3, label: "Deploy", sub: "Deployments", to: "/admin/fine-tuning-deployments" },
  { n: 4, label: "Eval", sub: "Evals", to: "/admin/fine-tuning-evals" },
  { n: 5, label: "Release", sub: "Models", to: "/admin/fine-tuning-models" },
];

export const FineTuningPipelineStepper = () => {
  const { pathname } = useLocation();
  const activeIdx = STEPS.findIndex((s) => pathname.startsWith(s.to));

  return (
    <div className="flex items-center gap-1 overflow-x-auto border-b border-gray-200 bg-white px-6 py-2 dark:border-gray-700 dark:bg-gray-800">
      {STEPS.map((s, i) => {
        const isActive = i === activeIdx;
        const isDone = activeIdx >= 0 && i < activeIdx;
        return (
          <div
            key={s.sub}
            className="flex flex-shrink-0 items-center"
          >
            <RouterLink
              to={s.to}
              title={`${s.label} · ${s.sub}`}
              className={clsx(
                "flex items-center gap-2 rounded-md px-2.5 py-1 transition-colors",
                isActive ? "bg-brand/10" : "hover:bg-gray-100 dark:hover:bg-gray-700",
              )}
            >
              <span
                className={clsx(
                  "flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-xs font-semibold",
                  isActive ? "bg-brand text-white" : isDone ? "bg-brand/20 text-brand" : "bg-gray-200 text-gray-500 dark:bg-gray-600 dark:text-gray-300",
                )}
              >
                {s.n}
              </span>
              <Text className={clsx("text-sm font-medium", isActive ? "text-brand" : "text-gray-600 dark:text-gray-300")}>{s.label}</Text>
              <Text className="hidden text-xs text-gray-400 sm:inline">{s.sub}</Text>
            </RouterLink>
            {i < STEPS.length - 1 && (
              <span
                aria-hidden
                className="px-1 text-gray-300 dark:text-gray-600"
              >
                →
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};
